<iris-chip-dropdown
  [chipTitle]="tag.meta.bulkModeGroupLabel"
  [headerTemplate]="chipMenuHeader"
  [options]="dropdownOptions"
  (itemRemoved)="removeItem($event)"
  >
</iris-chip-dropdown>

<ng-template #chipMenuHeader>
  @for (headerItem of chipMenuHeaderItems; track headerItem) {
    <div
      mat-menu-item
      clickStopPropagation
      [attr.data-test]="'module-filter-tag-chip-menu-item'+ headerItem.iconClass"
      class="d-flex align-items-center"
      (click)="headerItem.onclick()"
      >
      <span class="flex-grow-1">{{ headerItem.label | translate }}</span>
      <i class="far" [class]="headerItem.iconClass"></i>
    </div>
  }
</ng-template>
